import React, { useMemo } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import ClearIcon from '@mui/icons-material/Clear';
import DetectMobileHelper from '../../helpers/detect-mobile.helper';
import classes from './tips.module.scss';
import TipCard from '../../components/tip-card/TipCard';
import { resetAllTipFilters } from '../../../store/filters/tipFilters.slice';
import { TipsProps } from '../../interfaces/props/TipsProps';

const NOT_FOUND_BY_FILTERS_MESSAGE: string =
  'It looks like there are no tips for the selected criteria. Please clear filters or choose other categories';

const Tips = ({ tips, areFiltersEmpty, loading }: TipsProps) => {
  const dispatch = useDispatch();
  const tipsRender = useMemo(() => {
    const handleClearFilters = (event: React.MouseEvent<HTMLButtonElement>) => {
      dispatch(resetAllTipFilters());
    };

    if (tips.length === 0 && !areFiltersEmpty && !loading) {
      return (
        <>
          <Box
            className={`${classes['message-placeholder'] || ''} text-center d-flex justify-content-center align-items-center px-2`}
          >
            {NOT_FOUND_BY_FILTERS_MESSAGE}
          </Box>
          {DetectMobileHelper.isMobile() && (
            <Box className='border pt-1 mt-4 rounded' textAlign='center'>
              <Button
                className={classes.button}
                onClick={handleClearFilters}
              >
                <ClearIcon fontSize='small' />
                <Typography className='text-btn-primary'>
                  Clear All Filters
                </Typography>
              </Button>
            </Box>
          )}
        </>
      );
    }

    return tips.map((tip) => (
      <Box key={tip.id} className='mb-4'>
        <TipCard
          id={tip.id}
          attributes={tip.attributes}
        />
      </Box>
    ));
  }, [tips, areFiltersEmpty, loading, dispatch]);

  return (
    <Box className={`pt-2`}>
      {tipsRender}
    </Box>
  );
};

export default Tips;
